module.exports = __webpack_public_path__ + "4888a3d17632572cb9d154570e1677a6.svg";